import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const QuotedMessageDocFileIcon = (props: IconProps) => (
  <Icon w="16px" h="16px" viewBox="0 0 16 16" {...props}>
    <path d="M5.33317 10.6667H10.6665V12H5.33317V10.6667ZM5.33317 8.00004H10.6665V9.33337H5.33317V8.00004ZM9.33317 1.33337H3.99984C3.2665 1.33337 2.6665 1.93337 2.6665 2.66671V13.3334C2.6665 14.0667 3.25984 14.6667 3.99317 14.6667H11.9998C12.7332 14.6667 13.3332 14.0667 13.3332 13.3334V5.33337L9.33317 1.33337ZM11.9998 13.3334H3.99984V2.66671H8.6665V6.00004H11.9998V13.3334Z" />
  </Icon>
);

export default memo(QuotedMessageDocFileIcon);
